import { render, staticRenderFns } from "./SummaryTitle.vue?vue&type=template&id=02684109&scoped=true"
import script from "./SummaryTitle.vue?vue&type=script&lang=js"
export * from "./SummaryTitle.vue?vue&type=script&lang=js"
import style0 from "./SummaryTitle.vue?vue&type=style&index=0&id=02684109&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02684109",
  null
  
)

export default component.exports